<template lang="pug">
  .b-status(:class="{ [status]: true, gray }" v-if="!editable" :title="statusName") {{ statusName }}
  BaseTileDropdown(v-else :opened="dropdownOpened" @close="dropdownOpened = false")
    template(#selected)
      .b-status(:class="{ [status]: true, gray }" @click="dropdownOpened = !dropdownOpened").-clickable {{ statusName }}
    template(#default)
      .b-status(v-for="[code, name] in statusesInDropdown" :key="code" :class="code" @click="onStatusSelected(code)").-clickable {{ name }}
</template>

<script>
import BaseTileDropdown from '@/components/BaseTileDropdown.vue';
import { materialStatus } from '@/utils/enum';

export default {
  name: 'MaterialStatus', // TODO join with base status
  components: { BaseTileDropdown },
  model: {
    prop: 'status',
    event: 'change',
  },
  props: {
    status: String,
    editable: Boolean,
    gray: Boolean,
  },
  data() {
    return {
      dropdownOpened: false,
      statuses: { ...materialStatus },
    };
  },
  computed: {
    statusName() { return this.statuses[this.status]; },
    statusesInDropdown() { return Object.entries(this.statuses).filter(([code]) => code !== this.status); },
  },
  methods: {
    onStatusSelected(code) {
      this.dropdownOpened = false;
      this.$emit('change', code);
    },
  },
};
</script>

<style scoped lang="scss">
.status {
  display: inline-block;
  text-align: center;
  color: var(--color-white);
  font-weight: 700;
  font-size: 12px;
  line-height: 1.15;
  min-width: 100px;
  padding: 4px 0;
  border-radius: 4px;

  &--clickable {
    cursor: pointer;
  }

  &.gray {
    filter: grayscale(1);
    opacity: .6;
  }

  &.new { background-color: #a5d392; }
  &.progress { background-color: #ffd059; }
  &.paused { background-color: #cbcbcb; }
  &.review { background-color: #3680CC; }
  &.rework { background-color: #7a5e9f; }
  &.agreement { background-color: #E86863; }
  &.closed { background-color: #8b8b8b; }

  &.coordination { background-color: #7a5e9f; }
  &.contract { background-color: #E86863; }
  &.measuring { background-color: #ffd059; }
  &.production { background-color: #3680CC; }
  &.delivery { background-color: #7a5e9f; }
  &.assembly { background-color: #a5d392; }
  &.stock { background-color: #ffd059; }
}
</style>
